import I18n from 'I18n';
import JsonLd from 'marketplace-ui-common/components/elements/JsonLd';
import DocumentHead from 'marketplace-ui-common/components/portals/DocumentHead';
import { useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { Paths } from '../../constants/paths';
import { getFullPublicUrl } from '../../utils/urls';
import { useBreadcrumbs } from '../hooks/useBreadcrumbs';
import { jsx as _jsx } from "react/jsx-runtime";
export function StorefrontBreadcrumbStructuredData({
  backBreadcrumb,
  pathKey,
  productType,
  title
}) {
  const {
    collectionSlug,
    listingSlug
  } = useParams();
  const items = useBreadcrumbs({
    backBreadcrumb,
    pathKey,
    productType,
    slug: collectionSlug || listingSlug,
    title
  });
  const item = useMemo(() => {
    const itemName = itemPathKey => {
      switch (itemPathKey) {
        case 'HOME':
          return I18n.text('marketplaceStorefront.breadcrumbs.marketplace');
        case 'APPS':
          return I18n.text('marketplaceStorefront.breadcrumbs.apps');
        case 'AGENTS':
          return I18n.text('marketplaceStorefront.breadcrumbs.agents');
        case 'SEARCH_RESULTS':
          return I18n.text('marketplaceStorefront.breadcrumbs.explore');
        case 'FEATURED':
          return I18n.text('marketplaceStorefront.breadcrumbs.featured');
        case 'FEATURED_COLLECTION':
        case 'LISTING_DETAILS':
          return typeof title === 'string' ? title : String(title || '');
        default:
          return '';
      }
    };
    return {
      '@context': 'https://schema.org',
      '@type': 'BreadcrumbList',
      itemListElement: [...items.map((element, index) => ({
        '@type': 'ListItem',
        position: index + 1,
        item: {
          '@id': getFullPublicUrl(element.slug || Paths[element.pathKey]),
          name: itemName(element.pathKey)
        }
      }))]
    };
  }, [items, title]);
  return /*#__PURE__*/_jsx(DocumentHead, {
    children: /*#__PURE__*/_jsx(JsonLd, {
      item: item
    })
  });
}